import * as React from 'react';
import {ProductCompare} from "./ProductCompare";

export function CompareProduct() {
    return (
        <ProductCompare/>
    );

}
